import { render, staticRenderFns } from "./authorized.vue?vue&type=template&id=bfaa361a&scoped=true&"
import script from "./authorized.vue?vue&type=script&lang=js&"
export * from "./authorized.vue?vue&type=script&lang=js&"
import style0 from "./authorized.vue?vue&type=style&index=0&id=bfaa361a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa361a",
  null
  
)

export default component.exports